export const TYPES = [
  ["grant", "Grant or funding application"],
  ["patent", "Patent"],
  ["trade_mark", "Trade mark"],
  ["design", "Registered design"],
  ["copyright", "Copyright record"],
  ["know_how", "Confidential know-how"],
];

export const GROUPS = {
  common: ["For every application", [
    ["c1", "Business details: legal name, legal form, company number (if incorporated) and registered address"],
    ["c2", "A main contact, and the person authorised to approve or sign"],
    ["c3", "A plain-English description of the project: the problem, your solution and what is new"],
    ["c4", "Development stage, plus any prototype or testing evidence"],
    ["c5", "Who created or invented it, and whether employees, contractors or a university were involved"],
    ["c6", "Any agreements that give ownership to the business"],
    ["c7", "Where and when it has been shown publicly (website, pitch, publication, sales material)"],
  ]],
  grant: ["Grant or funding application", [
    ["g1", "The competition brief, with the deadline and time zone, from the official source"],
    ["g2", "A check against each mandatory eligibility rule"],
    ["g3", "A project plan with milestones, risks and a timetable"],
    ["g4", "A costed budget by category, with quotes for major items"],
    ["g5", "The funding rate, and how you will pay your share and manage cash flow"],
    ["g6", "Latest accounts or management accounts, and financial forecasts"],
    ["g7", "CVs or short profiles of key people"],
    ["g8", "Evidence for market claims (research, letters of support, customer interest)"],
    ["g9", "Partner details and agreement in principle, if partners are required"],
    ["g10", "Details of any previous public funding (subsidy control)"],
    ["g11", "A public summary with no confidential technical detail"],
  ]],
  patent: ["Patent", [
    ["p1", "A structured invention disclosure: technical field, problem, closest known solutions, how it works, key features"],
    ["p2", "Drawings or diagrams of the invention"],
    ["p3", "Names and addresses of every inventor"],
    ["p4", "Proof the applicant owns the invention (employment terms, assignments)"],
    ["p5", "A disclosure log: who has seen it, when, and under what NDA"],
    ["p6", "Preliminary prior-art search results"],
    ["p7", "A budget for official fees (£75 application, £200 search, £130 examination online) plus professional fees"],
    ["p8", "A registered patent attorney to review before anything is filed"],
  ]],
  trade_mark: ["Trade mark", [
    ["t1", "The exact mark: word(s) and/or a logo image"],
    ["t2", "Owner name and address (person or company)"],
    ["t3", "The goods and services you will use it for, and their classes"],
    ["t4", "Search results for similar existing marks"],
    ["t5", "Fees: £205 online for one class, £60 for each extra class"],
  ]],
  design: ["Registered design", [
    ["d1", "Clear images or drawings showing only the design, from several views"],
    ["d2", "The designer's name and the owner's details"],
    ["d3", "The date the design was first shown publicly (a 12-month grace period applies)"],
    ["d4", "A budget for the official application fee"],
  ]],
  copyright: ["Copyright record", [
    ["r1", "Copies of the work and each version, with dates"],
    ["r2", "Authors' names, and whether they were employees or contractors"],
    ["r3", "Agreements assigning copyright to the business"],
    ["r4", "An understanding that the UK has no official copyright register; a record is evidence only"],
  ]],
  know_how: ["Confidential know-how", [
    ["k1", "A list of the confidential processes, formulas, data or methods"],
    ["k2", "Who has access to each item, and how access is controlled"],
    ["k3", "An NDA template, and signed NDAs for anyone outside the business"],
    ["k4", "Confidentiality terms in employee and contractor agreements"],
  ]],
};
